/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useCallback } from "react";
import { Table, Button, Input, Space, Modal, notification, Dropdown, Tag, Select, Checkbox, TableColumnType } from "antd";
import DeviceUpdate from "../DeviceUpdate";
import UploadFile from "../UploadFile";
import TransferModal from "../../SystemSetting/Devices/TransferModal";
import { useParams } from 'react-router-dom'
import {
    searchDevices, SearchDevicesPayload,
    updateDevice, createDevices, batchImportDevices, deleteDevices,
    toggleSwitchesCommand,
} from "../../../api/device";
import { useRequest } from "../../../hooks";
import { useApp } from "../../../model";
import { useNavigate } from "react-router-dom";
import { DEVICE_SN_PREFIX, deviceDefaultValues } from "../../../constants";
import { useAuthInfo } from "../../../hooks";
import IfNotObserver from "../../common/IfNotObserver";
import { textRender, downloadFile } from "../../../utils";
import { apis } from "../../../constants";

const defaultValues = {
    ...deviceDefaultValues
};

const ALL = -1;
export default function DeviceList({ isHistory = false }) {
    const app = useApp();
    const { loadingAuthInfo, isElectrician, isObserver, isManager } = useAuthInfo();
    const { projectId } = useParams();
    const navigate = useNavigate();
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [uploading, setUploading] = useState(false)
    const [showCreate, setShowCreate] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showUpload, setShowUpload] = useState(false)
    const [batchUploadFile, setBatchUploadFile] = useState();
    const [edittingRecord, setEdittingRecord] = useState<any>({ ...defaultValues });
    const [toggleRecord, setToggleRecord] = useState<DeviceRecord>();

    const [searchParams, setSearchParams] = useState<Partial<SearchDevicesPayload>>({
        pageNum: 1,
        pageSize: 10,
        online: null,
    });
    const [toggling, setToggling] = useState(false);
    const fetchData = useCallback(() => {
        app.setState('deviceMapDataSourceRefreshKey', Symbol())
        return searchDevices(projectId as string, {
            ...searchParams
        }, isHistory)
    }, [projectId, searchParams, isHistory]);
    const [selectedRows, setSelectedRows] = useState<DeviceRecord[]>([]);

    const [currentSelectedMac, setCurrentSelectedMac] = useState('');
    const [transfering, setTransfering] = useState(false);
    const { data, loading } = useRequest<PagedData<DeviceRecord>>(fetchData);
    const [selectedSwitches, setSelectedSwitches] = useState<any[]>([]);
    const [downloading, setDownloading] = useState(false)
    const isEdit = !!edittingRecord?.id;
    const toggleSwitches = (action: string) => {
        setToggling(true);
        const isApplyAll = selectedSwitches.includes(ALL)
        toggleSwitchesCommand({
            "controlType": action,
            "devSn": toggleRecord?.device?.deviceSn,
            "gwMac": toggleRecord?.gatewayMac,
            "is5G": toggleRecord?.device?.type === '5G',
            "projectId": toggleRecord?.projectId,
            "switchList": isApplyAll ? [] : selectedSwitches,
            isApplyAll: isApplyAll,
        })
            .then(() => {
                setToggling(false);
                setToggleRecord(undefined);
                setSelectedSwitches([]);
                notification.success({ message: '操作成功' })
            })
            .catch(() => {
                notification.error({ message: '操作失败,请重试' })
                setToggling(false);
            })
    }
    return (
        <div>
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Space>
                    <Input.Search allowClear onSearch={queryDeviceSN => {
                        setSearchParams({
                            ...searchParams,
                            queryDeviceSN
                        })
                    }} onBlur={e => {
                        setSearchParams({
                            ...searchParams,
                            queryDeviceSN: e.target.value,
                        })
                    }} onKeyUp={e => {
                        if (e.key === 'Enter') {
                            setSearchParams({
                                ...searchParams,
                                queryDeviceSN: (e.target as any).value,
                            })
                        }
                    }} placeholder="请输入设备号" />
                    {
                        isHistory ? null :
                            <Select
                                style={{ width: 100 }}
                                value={searchParams.online}
                                options={[
                                    { label: '全部', value: null },
                                    { label: '在线', value: true },
                                    { label: '离线', value: false },
                                ]}
                                onChange={online => {
                                    setSearchParams({
                                        ...searchParams,
                                        online
                                    })
                                }}
                            />
                    }
                </Space>
                <div style={{ gap: 20, display: 'flex' }}>
                    {
                        isHistory ? null :
                            <IfNotObserver>
                                <Button type='primary' onClick={(() => {
                                    setShowCreate(true);
                                    setEdittingRecord({ ...defaultValues })
                                })}>添加设备</Button>
                                <Button type='primary' onClick={(() => setShowUpload(true))}>批量上传</Button>
                                <Button loading={downloading} type='primary' onClick={() => {
                                    setDownloading(true)
                                    downloadFile(apis.deviceDownload.replace('{projectId}', String(projectId)), {})
                                        .then(() => {
                                            setDownloading(false)
                                        })
                                        .catch(() => {
                                            setDownloading(false)
                                        })
                                }}>数据导出</Button>
                            </IfNotObserver>
                    }
                </div>
            </Space>
            <Modal destroyOnClose title='分闸/合闸'
                open={!!toggleRecord}
                onCancel={() => setToggleRecord(undefined)}
                footer={null}
            >
                <h5>设备序列号: {toggleRecord?.device?.deviceSn}</h5>
                <Select maxCount={1} placeholder='请选择开关' value={selectedSwitches} style={{ width: '100%' }}
                    options={[{
                        value: ALL, label: '全部'
                    },
                    ...new Array(toggleRecord?.switchCount).fill(0).map((_, index) => {
                        return {
                            value: index + 1,
                            label: '开关' + (index + 1)
                        }
                    })]}
                    mode='multiple'
                    onChange={(ids: any[]) => {
                        setSelectedSwitches(ids)
                    }}
                ></Select>
                <br />
                <div style={{ display: 'flex', flex: 1, justifyContent: 'end', padding: 20, gap: 30 }}>
                    <Button loading={toggling} type='primary' onClick={() => {
                        toggleSwitches('close')
                    }}>分闸</Button>
                    <Button loading={toggling} type='primary' onClick={() => {
                        toggleSwitches('open')
                    }}>合闸</Button>
                </div>
            </Modal>
            <Modal destroyOnClose title={`${isEdit ? '编辑' : '添加'}设备`} footer={null} open={showCreate} onCancel={() => setShowCreate(false)} >
                <DeviceUpdate isEdit={isEdit} projectId={projectId} submitLoading={submitLoading} initialValues={edittingRecord} onComplete={(values: any) => {
                    setSubmitLoading(true)
                    const {
                        description, deviceSn, type, switchCount, ...basic
                    } = values
                    console.log(values, basic)
                    if (isEdit) {
                        updateDevice(projectId as string, edittingRecord.device!.deviceSn, {
                            ...edittingRecord,
                            ...basic,
                            switchCount: Number(switchCount),
                            device: {
                                ...edittingRecord.device,
                                description, deviceSn, type, switchCount: Number(switchCount),
                            },
                        })
                            .then(() => {
                                setSubmitLoading(false)
                                notification.success({ message: '更新成功' })
                                setShowCreate(false)
                                setSearchParams({ ...searchParams })
                                setEdittingRecord({ ...defaultValues })
                            })
                            .catch((err) => {
                                console.error(err)
                                notification.error({ message: err.message || '更新失败,请重试' })
                                setSubmitLoading(false)
                            })
                    } else {
                        createDevices(projectId as string, [
                            {
                                ...basic,
                                switchCount: Number(switchCount),
                                device: {
                                    description, deviceSn: DEVICE_SN_PREFIX + deviceSn, type, switchCount: Number(switchCount),
                                },
                            }
                        ])
                            .then(() => {
                                setSubmitLoading(false)
                                notification.success({ message: '创建成功' })
                                setShowCreate(false)
                                setSearchParams({ ...searchParams, pageNum: 1 })
                            })
                            .catch((err) => {
                                console.error(err)
                                notification.error({ message: err.message || '创建失败,请重试' })
                                setSubmitLoading(false)
                            })
                    }
                }} />
            </Modal>
            <Modal okButtonProps={{
                disabled: !batchUploadFile,
                loading: uploading,
            }} title='批量上传' onOk={() => {
                if (!batchUploadFile || !projectId) return;
                setUploading(true);
                const data = new FormData();
                data.append('file', batchUploadFile)
                batchImportDevices(projectId, data)
                    .then(() => {
                        setUploading(false)
                        setShowUpload(false)
                        notification.success({ message: '上传成功' })
                        setBatchUploadFile(undefined);
                        setSearchParams({
                            ...searchParams,
                            pageNum: 1
                        })
                    })
                    .catch((err: any) => {
                        setUploading(false)
                        notification.error({ message: err.message || '上传失败,请重试' })
                    })
            }} open={showUpload} onCancel={() => setShowUpload(false)} >
                <UploadFile onFileChange={setBatchUploadFile} />
            </Modal>
            <br />
            {
                isHistory ? null :
                    <>

                        <Button onClick={() => {
                            setShowTransferModal(true)
                        }} loading={transfering} disabled={!selectedRows.length} type='link'>批量迁移{selectedRows.length ? `(${selectedRows.length})` : ''}</Button>
                        {
                            currentSelectedMac !== '' ? <span style={{ color: '#aaa' }}>*当前选取设备所属网关: {String(currentSelectedMac)}, 请选择相同网关下的设备</span> : <span></span>
                        }
                        <br />
                    </>
            }
            <TransferModal
                showTransferModal={showTransferModal}
                setShowTransferModal={setShowTransferModal}
                selectedRows={selectedRows.map(i => i.device as Device)}
                originMac={currentSelectedMac}
                onDone={() => {
                    setSelectedRows([]);
                    setSearchParams({ ...searchParams });
                }}
            />
            <Table rowKey={'id'} loading={loading} dataSource={data?.data} scroll={{ x: 1 }}
                rowSelection={isHistory ? undefined : {
                    renderCell(checked, record, index, originNode) {
                        return !!currentSelectedMac && record.gatewayMac !== currentSelectedMac ? <Checkbox disabled /> : originNode
                    },
                    onSelect(row) {
                        setCurrentSelectedMac(row.gatewayMac);
                    },
                    hideSelectAll: true,
                    selectedRowKeys: selectedRows.map(i => i.id),
                    onChange(_, selectedRows) {
                        setSelectedRows(selectedRows as any[])
                    },
                }}
                columns={[
                    {
                        dataIndex: 'name',
                        title: '展位号',
                        width: 150,
                        fixed: true,
                    },
                    {
                        width: 180,
                        dataIndex: 'deviceSn',
                        render: (_, row) => row.device?.deviceSn,
                        title: '设备序列号',
                        fixed: true,
                    },
                    isHistory ? {
                        width: 0,
                    } : {
                        dataIndex: 'online',
                        render: (_, row) => {
                            return row.device?.online ? <Tag color='green'>在线</Tag> : <Tag color='red'>离线</Tag>
                        },
                        title: '设备状态',
                        width: 100,
                    },
                    {
                        dataIndex: 'gatewayMac',
                        width: 180,
                        title: '网关MAC地址',
                        render(gatewayMac, row) {
                            return row.device?.type === '4G' ? '-' : gatewayMac
                        }
                    },
                    {
                        dataIndex: 'switchCount',
                        title: '开关数量',
                        width: 100,
                    },
                    {
                        dataIndex: 'type',
                        render: (_, row) => row.device?.type,
                        title: '设备类型',
                        width: 100,
                    },
                    {
                        dataIndex: 'electricalBoxCapacity',
                        title: '电箱容量(A)',
                        width: 150,
                    },
                    {
                        dataIndex: 'isControlled',
                        title: '是否受控',
                        width: 100,
                        render: (isControlled) => isControlled ? '是' : '否'
                    },
                    {
                        dataIndex: 'isKeepOnline',
                        title: '是否24小时保电',
                        width: 150,
                        render: (isKeepOnline) => isKeepOnline ? '是' : '否'
                    },
                    {
                        dataIndex: 'isPowerSupply',
                        title: '是否动力电源',
                        width: 150,
                        render: (isPowerSupply) => isPowerSupply ? '是' : '否'
                    },
                    {
                        dataIndex: 'createDatetime',
                        title: '创建时间',
                        width: 200,
                        render: (_, row) => row.createdUser?.createDatetime
                    },
                    {
                        dataIndex: 'creator',
                        title: '创建人',
                        width: 100,
                        render: (_, row) => row.createdUser?.userName
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        width: 100,
                        render: (_, row) => {
                            const isProjectCreatedByMe = row.projectDto.createdBy === app.currentUserId;
                            return (
                                <Dropdown menu={{
                                    items: [
                                        isHistory ? null : {
                                            label: <a onClick={(e) => {
                                                e.preventDefault()
                                                navigate(`/project/${projectId}/logs/${row.device?.deviceSn}`);
                                            }}>查看实时数据</a>,
                                            type: 'group',
                                        },
                                        isHistory ? null : {
                                            label: <a onClick={(e) => {
                                                e.preventDefault()
                                                navigate(`/project/${projectId}/alarms/${row.device?.deviceSn}`);
                                            }}>查看告警信息</a>,
                                            type: 'group',
                                        },
                                        {
                                            label: <a onClick={(e) => {
                                                e.preventDefault()
                                                navigate(`/history-logs?devSn=${row.device?.deviceSn}&projectId=${row.projectId}&isHistory=${isHistory ? 1 : 0}`);
                                            }}>查看实时日志</a>,
                                            type: 'group',
                                        },
                                        {
                                            label: <a onClick={(e) => {
                                                e.preventDefault()
                                                navigate(`/history-alarms?devSn=${row.device?.deviceSn}&projectId=${row.projectId}&isHistory=${isHistory ? 1 : 0}`);
                                            }}>查看告警日志</a>,
                                            type: 'group',
                                        },
                                        isHistory ? null : {
                                            label: <Button loading={loadingAuthInfo} style={{
                                                padding: 0, margin: 0, height: '1em'
                                            }} disabled={!row.device?.online || isElectrician || isObserver || (
                                                isManager && !isProjectCreatedByMe
                                            )} type="link" onClick={() => {
                                                setToggleRecord({
                                                    ...row,
                                                });
                                            }}>分闸/合闸</Button>,
                                            type: 'group',
                                        },
                                        isHistory ? null : {
                                            label: <Button disabled={isObserver || (
                                                isManager && !isProjectCreatedByMe
                                            )} style={{
                                                padding: 0, margin: 0, height: '1em'
                                            }} type="link" onClick={() => {
                                                setEdittingRecord({
                                                    ...row.device,
                                                    ...row,
                                                });
                                                setShowCreate(true)
                                            }}>编辑</Button>,
                                            type: 'group',
                                        },
                                        isHistory ? null : {
                                            label: <Button disabled={isObserver || (
                                                isManager && !isProjectCreatedByMe
                                            )} style={{
                                                padding: 0, margin: 0, height: '1em'
                                            }} type="link" onClick={() => {
                                                Modal.confirm({
                                                    title: '确认删除?',
                                                    onOk() {
                                                        deleteDevices(projectId as string, [row.device?.deviceSn])
                                                            .then(() => {
                                                                notification.success({ message: '删除成功' })
                                                                setSearchParams({
                                                                    ...searchParams
                                                                })
                                                            })
                                                            .catch(() => {
                                                                notification.error({ message: '删除失败,请重试' })
                                                            })
                                                    }
                                                })
                                            }}>删除</Button>,
                                            type: 'group',
                                        },
                                    ].filter(Boolean) as any[]
                                }}>
                                    <Button type='link'>···</Button>
                                </Dropdown>
                            )
                        }
                    },
                ]}
                pagination={{
                    total: data?.total,
                    pageSize: searchParams.pageSize,
                    current: searchParams.pageNum,
                    onChange(pageNum, pageSize) {
                        setSearchParams({
                            ...searchParams,
                            pageSize,
                            pageNum
                        })
                    },
                }}
            />
        </div>
    )
}